// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2gPB3","clinicsSelect":"TableHeading_clinicsSelect__5sa8t"};